module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/200-south-africa-a4b6fd2459e638ee470e1010200a0c04.svg";